"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { AnimatedNumber, classNames, formatAddress, TextOverflowTooltip } from "@opensea/ui-kit";
import { normalizeAddress } from "@opensea/utils";
import { useTranslations } from "next-intl";
import { useCallback } from "react";
import { useContextSelector } from "use-context-selector";
import { AsteriskText } from "@/components/profile/AsteriskText";
import { ProfileSettingsContext } from "@/components/profile/ProfileSettingsProvider";
import { getProfileUrlByIdentifier } from "@/components/profile/utils";
import { AccountSwitcherAccountItemsFragment } from "./AccountSwitcherAccountItems.fragment";
import { AccountSwitcherChip } from "./AccountSwitcherChip";
import { AccountSwitcherItem, AccountSwitcherItemAvatar, AccountSwitcherItemContent, AccountSwitcherItemDescription, AccountSwitcherItemTitle } from "./AccountSwitcherItem";
export function AccountSwitcherTopAccount(t0) {
  const $ = _c(41);
  const {
    account,
    walletCount,
    usdTotalValue,
    isLink: t1,
    variant: t2,
    className
  } = t0;
  const isLink = t1 === undefined ? true : t1;
  const variant = t2 === undefined ? "full" : t2;
  const t = useTranslations("AccountSwitcherTopAccount");
  let data;
  let normalizedAddress;
  let t3;
  if ($[0] !== account) {
    data = readFragment(AccountSwitcherAccountItemsFragment, account);
    normalizedAddress = normalizeAddress(data.address);
    t3 = getProfileUrlByIdentifier(data.username || normalizedAddress);
    $[0] = account;
    $[1] = data;
    $[2] = normalizedAddress;
    $[3] = t3;
  } else {
    data = $[1];
    normalizedAddress = $[2];
    t3 = $[3];
  }
  const href = t3;
  const hideWalletWorth = useContextSelector(ProfileSettingsContext, _temp);
  let t4;
  if ($[4] !== hideWalletWorth) {
    t4 = value => {
      if (hideWalletWorth) {
        return <AsteriskText />;
      }
      return <AnimatedNumber display="usd" value={value} />;
    };
    $[4] = hideWalletWorth;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const renderUsdBalance = t4;
  let t5;
  if ($[6] !== t || $[7] !== walletCount) {
    t5 = t("topAccount.walletsAndValue", {
      walletCount
    });
    $[6] = t;
    $[7] = walletCount;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const walletCountText = t5;
  let t6;
  if ($[9] !== renderUsdBalance || $[10] !== usdTotalValue) {
    t6 = renderUsdBalance(usdTotalValue);
    $[9] = renderUsdBalance;
    $[10] = usdTotalValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const usdBalanceElement = t6;
  const t7 = variant === "compact";
  const t8 = variant === "full";
  let t9;
  if ($[12] !== className || $[13] !== t7 || $[14] !== t8) {
    t9 = classNames("rounded-lg", {
      "h-16 bg-bg-secondary": t7,
      "h-18": t8
    }, className);
    $[12] = className;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = isLink ? href : undefined;
  const t11 = `top-${normalizedAddress}`;
  const t12 = variant === "compact" ? 36 : 48;
  const t13 = data.imageUrl || undefined;
  let t14;
  if ($[16] !== normalizedAddress || $[17] !== t12 || $[18] !== t13) {
    t14 = <AccountSwitcherItemAvatar seed={normalizedAddress} size={t12} src={t13} />;
    $[16] = normalizedAddress;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = variant === "full";
  let t16;
  if ($[20] !== t15) {
    t16 = classNames("gap-1", {
      "gap-1.5": t15
    });
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== data.displayName || $[23] !== normalizedAddress) {
    t17 = data.displayName || formatAddress(normalizedAddress);
    $[22] = data.displayName;
    $[23] = normalizedAddress;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t17) {
    t18 = <AccountSwitcherItemTitle><TextOverflowTooltip className="max-w-[150px]" disabled={true}>{t17}</TextOverflowTooltip></AccountSwitcherItemTitle>;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== usdBalanceElement || $[28] !== variant || $[29] !== walletCountText) {
    t19 = variant === "full" ? <AccountSwitcherItemDescription className="flex items-center gap-2"><AccountSwitcherChip>{walletCountText}</AccountSwitcherChip><AccountSwitcherChip>{usdBalanceElement}</AccountSwitcherChip></AccountSwitcherItemDescription> : <AccountSwitcherItemDescription className="capitalize"><AccountSwitcherChip className="h-4">{walletCountText}</AccountSwitcherChip></AccountSwitcherItemDescription>;
    $[27] = usdBalanceElement;
    $[28] = variant;
    $[29] = walletCountText;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t16 || $[32] !== t18 || $[33] !== t19) {
    t20 = <AccountSwitcherItemContent className={t16}>{t18}{t19}</AccountSwitcherItemContent>;
    $[31] = t16;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t14 || $[38] !== t20 || $[39] !== t9) {
    t21 = <AccountSwitcherItem className={t9} href={t10} key={t11}>{t14}{t20}</AccountSwitcherItem>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t14;
    $[38] = t20;
    $[39] = t9;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  return t21;
}
function _temp(state) {
  return state.hideWalletWorth;
}